import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
class SuggestStoreG extends StoreExt {
    @observable queryMyQuestionList: any = []
    @observable total: number
    @observable current: number = 1
    @action
    getQueryMyQuestion = async (param: any = { current: 1, pageSize: 10 }) => {
        try {
            const res = await this.api.queryMyQuestion(param)
            if (res && res.list instanceof Array) {
                res.list.map((item) => {
                    item.image1 = JSON.parse(item.image1)
                    item.answerList.map((item1) => {
                        item1.image1 = JSON.parse(item1.image1)
                    })
                })
            }
            runInAction(() => {
                this.queryMyQuestionList = [...res.list]
                this.total = res.total
                this.current = res.current
            })
        } catch (error) {
        }
    }
    @action
    clearMyquestion = () => {
        this.queryMyQuestionList = []
        this.current = 1
    }
}
const suggestStoreG = new SuggestStoreG()
export { suggestStoreG, SuggestStoreG }